[
  {
    "_note": "Governments (Phase 10a, ADR-0059). Every effect has code behind it. maxScienceRate caps the science slider. dragMultiplier scales the distance loss; dragFlat is a loss every city but the capital pays regardless of distance. tilePenalty: a tile yielding more than 2 of food, production or gold yields one less of it. goldTileBonus: extra gold on every worked tile that already yields at least goldTileMinimum gold. freeUnitsPerCity replaces economy.freeUnitsPerCity. contentment: citizens kept content in every city. garrisonContentment / maxGarrisonContentment: what each soldier in a city is worth, and the most a garrison can do. warWeariness scales how much war losses make citizens discontented (rules.weariness). productionPercent and culturePercent raise every city's production and culture. aiValue: how much each AI personality wants it ('base' for any other).",
    "key": "anarchy",
    "name": "Anarchy",
    "requiresTech": null,
    "selectable": false,
    "summary": "The old order has fallen and the new one is not yet in place.",
    "effects": {
      "maxScienceRate": 0,
      "dragMultiplier": 2,
      "dragFlat": 0,
      "tilePenalty": true,
      "goldTileBonus": 0,
      "goldTileMinimum": 1,
      "freeUnitsPerCity": 2,
      "contentment": 0,
      "garrisonContentment": 1,
      "maxGarrisonContentment": 2,
      "warWeariness": 0,
      "productionPercent": 0,
      "culturePercent": 0
    },
    "aiValue": { "base": -100 }
  },
  {
    "key": "despotism",
    "name": "Despotism",
    "requiresTech": null,
    "selectable": true,
    "summary": "Rule by one strong hand. Rich land is wasted, distant cities slip away, but nobody asks about the war.",
    "effects": {
      "maxScienceRate": 60,
      "dragMultiplier": 1.5,
      "dragFlat": 0,
      "tilePenalty": true,
      "goldTileBonus": 0,
      "goldTileMinimum": 1,
      "freeUnitsPerCity": 2,
      "contentment": 0,
      "garrisonContentment": 1,
      "maxGarrisonContentment": 2,
      "warWeariness": 0,
      "productionPercent": 0,
      "culturePercent": 0
    },
    "aiValue": { "base": 0 }
  },
  {
    "key": "monarchy",
    "name": "Monarchy",
    "requiresTech": "kingship",
    "selectable": true,
    "summary": "A crown and a court. Orderly cities, a cheap army, and wars the people tolerate.",
    "effects": {
      "maxScienceRate": 70,
      "dragMultiplier": 1,
      "dragFlat": 0,
      "tilePenalty": false,
      "goldTileBonus": 0,
      "goldTileMinimum": 1,
      "freeUnitsPerCity": 3,
      "contentment": 1,
      "garrisonContentment": 1,
      "maxGarrisonContentment": 3,
      "warWeariness": 0.5,
      "productionPercent": 0,
      "culturePercent": 0
    },
    "aiValue": { "base": 10, "militarist": 16, "expansionist": 13 }
  },
  {
    "key": "theocracy",
    "name": "Theocracy",
    "requiresTech": "monotheism",
    "selectable": true,
    "summary": "Faith governs. Content cities and a flourishing culture, at some cost to learning.",
    "effects": {
      "maxScienceRate": 60,
      "dragMultiplier": 0.9,
      "dragFlat": 0,
      "tilePenalty": false,
      "goldTileBonus": 0,
      "goldTileMinimum": 1,
      "freeUnitsPerCity": 2,
      "contentment": 2,
      "garrisonContentment": 1,
      "maxGarrisonContentment": 2,
      "warWeariness": 0.25,
      "productionPercent": 0,
      "culturePercent": 50
    },
    "aiValue": { "base": 9, "builder": 15 }
  },
  {
    "key": "republic",
    "name": "Republic",
    "requiresTech": "the_republic",
    "selectable": true,
    "summary": "Citizens vote and trade. Commerce thrives and the empire holds together, but armies cost more and losses are resented.",
    "effects": {
      "maxScienceRate": 80,
      "dragMultiplier": 0.8,
      "dragFlat": 0,
      "tilePenalty": false,
      "goldTileBonus": 1,
      "goldTileMinimum": 2,
      "freeUnitsPerCity": 1,
      "contentment": 0,
      "garrisonContentment": 0,
      "maxGarrisonContentment": 0,
      "warWeariness": 1,
      "productionPercent": 0,
      "culturePercent": 0
    },
    "aiValue": { "base": 16, "trader": 22, "scientist": 19, "militarist": 6 }
  },
  {
    "key": "democracy",
    "name": "Democracy",
    "requiresTech": "democracy",
    "selectable": true,
    "summary": "Power to the many. The richest and most learned of governments, and the least patient with war.",
    "effects": {
      "maxScienceRate": 90,
      "dragMultiplier": 0.4,
      "dragFlat": 0,
      "tilePenalty": false,
      "goldTileBonus": 1,
      "goldTileMinimum": 2,
      "freeUnitsPerCity": 0,
      "contentment": 0,
      "garrisonContentment": 0,
      "maxGarrisonContentment": 0,
      "warWeariness": 1.5,
      "productionPercent": 0,
      "culturePercent": 0
    },
    "aiValue": { "base": 20, "scientist": 25, "trader": 25, "militarist": 4 }
  },
  {
    "key": "communism",
    "name": "Communism",
    "requiresTech": "industrialisation",
    "selectable": true,
    "summary": "The state owns everything. Every city loses the same share however far it is, factories work harder, and soldiers keep order.",
    "effects": {
      "maxScienceRate": 80,
      "dragMultiplier": 0,
      "dragFlat": 0.15,
      "tilePenalty": false,
      "goldTileBonus": 0,
      "goldTileMinimum": 1,
      "freeUnitsPerCity": 3,
      "contentment": 1,
      "garrisonContentment": 2,
      "maxGarrisonContentment": 4,
      "warWeariness": 0.25,
      "productionPercent": 10,
      "culturePercent": 0
    },
    "aiValue": { "base": 17, "militarist": 22, "builder": 18 }
  }
]
